export default __webpack_public_path__ + "static/media/NO164_SUNGLASSESxPM_BLACKM.7aaa7473.mp4";